import React, {Component} from "react";
import {Button, Col, Row} from "react-bootstrap";
import {alertActions} from "../../../store/actions/AlertActions";
import {
  deleteRetirementType,
  findAllRetirementType,
  getAllProcessStatus,
  getAllProcessType,
  getAllScenario,
} from "../../../services/RequestService.js";
import {connect} from "react-redux";
import "./SettingsProcessPage.css";
import ModalProcessType from "../../../components/settings/process/ModalProcessType";
import ModalProcessStatus from "../../../components/settings/process/ModalProcessStatus";
import ModalScenario from "../../../components/settings/process/ModalScenario";
import ModalScenarioDelete from "../../../components/settings/process/ModalScenarioDelete";
import ModalPaymentMethod from "../../../components/settings/process/ModalPaymentMethod";
import {Header, Loading, PageContainer, TableComponent,} from "../../../genericComponents";
import ModalProcessStatusDelete from "../../../components/settings/process/ModalProcessStatusDelete";
import ModalProcessTypeDelete from "../../../components/settings/process/ModalProcessTypeDelete";
import ModalRetirementType from "../../../components/settings/process/ModalRetirementType";
import {withConfirm} from "../../../genericComponents/ConfirmDialog";

class SettingsProcessPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allProcessStatus: [],
      allProcessStatusList: null,
      currentAllProcessStatus: [],
      showModalProcessStatusDelete: false,
      selectedProcessStatus: null,
      showModalProcessTypeDelete: false,
      selectedProcessType: null,

      allProcessType: [],
      allProcessTypeList: null,
      currentAllProcessTypeList: [],

      allScenarios: [],
      allScenariosList: null,
      currentAllScenarios: [],

      allPaymentMethods: null,
      currentAllPaymentMethods: [],

      allRetirementType: null,
      currentAllRetirementType: [],

      showModalProcessType: false,
      showModalProcessStatus: false,
      showModalEditProcessType: false,
      showModalScenario: false,
      showModalScenarioDelete: false,
      showModalRetirementType: false,
      id: null,
      name: null,
      deadlineDays: null,
      parcel: "",
      typeOfPayment: "",
      payAtTheBeginning: "",
      value: "",
      description: "",
      contracts: [],

      loadingCount: null,

      // PAYMENT METHOD
      showEditPaymentMethodModal: false,
      paymentMethod: null,

      // Filtros client-side (por coluna) de cada tabela
      filterProcessStatus: "",
      filterProcessType: "",
      filterScenario: "",
      filterRetirementType: "",
    };
  }

  fetchRequests = () => {
    this.setState(
      (state) => ({
        loadingCount: !state.loadingCount ? 4 : state.loadingCount + 4,
      }),
      () => {
        getAllProcessType().then((res) => {
          if (res.ok) {
            for (let i = 0; i < res.data.length; i++) {
              let a = res.data[i];
              a["documentsLength"] = a.documentsType.length;
            }
            this.setState((state) => ({
              allProcessType: res.data,
              allProcessTypeList: res.data
                .map((item) => ({
                  id: item.id,
                  name: item.name,
                  documentsLength: Number(item.documentsLength),
                }))
                .sort((a, b) => (a.id > b.id ? 1 : -1)),
              loadingCount: state.loadingCount - 1,
            }));
          }
        });
        getAllProcessStatus().then((res) => {
          if (res.ok) {
            this.setState((state) => ({
              allProcessStatus: res.data,
              allProcessStatusList: res.data
                .map((item) => ({
                  id: item.id,
                  name: item.name,
                }))
                .sort((a, b) => (a.id > b.id ? 1 : -1)),
              loadingCount: state.loadingCount - 1,
            }));
          }
        });
        getAllScenario().then((res) => {
          if (res.ok) {
            this.setState((state) => ({
              allScenarios: res.data,
              allScenariosList: res.data
                .map((item) => ({
                  id: item.id,
                  name: item.name,
                  description: item.description,
                }))
                .sort((a, b) => (a.id > b.id ? 1 : -1)),
              loadingCount: state.loadingCount - 1,
            }));
          }
        });

        findAllRetirementType().then((res) =>
          this.setState((state) => ({
            allRetirementType: res.data.sort((a, b) =>
              a.id > b.id ? 1 : -1
            ),
            loadingCount: state.loadingCount - 1,
          }))
        );
      }
    );
  };

  componentDidMount = () => {
    this.fetchRequests();
  };

  setShowModalProcessType = (showModalProcessType, item, wasUpdated) => {
    let sd = {};
    if (item?.documentsType) {
      for (let i = 0; i < item.documentsType.length; i++) {
        let a = item.documentsType[i];
        sd[a.name] = a.id;
      }
    }
    this.setState({
      showModalProcessType: showModalProcessType,
      id: item?.id ?? null,
      name: item?.name ?? null,
      deadlineDays: item?.deadlineDays ?? null,
      parcel: item?.parcel ?? null,
      typeOfPayment: item?.typeOfPayment ?? null,
      payAtTheBeginning: item?.payAtTheBeginning ?? null,
      value: item?.value ?? null,
      contracts: item?.contracts ?? null,
      selectedDocuments: sd,
      isTicketParcel: item?.useTicket,
      ticketParcel: item?.ticketParcels,
      isCreditCard: item?.useCreditCard,
      creditCardParcel: item?.creditCardParcels,
    });
    if (!showModalProcessType && wasUpdated) {
      this.componentDidMount();
    }
  };

  setShowModalProcessStatus = (showModalProcessStatus, item, wasUpdated) => {
    this.setState({ showModalProcessStatus });
    if (!showModalProcessStatus && wasUpdated) {
      this.componentDidMount();
    }
  };

  setShowModalEditProcessStatus = (
    showModalEditProcessStatus,
    item,
    wasUpdated
  ) => {
    this.setState({
      showModalEditProcessStatus,
      id: item?.id ?? null,
      name: item?.name ?? null,
    });
    if (!showModalEditProcessStatus && wasUpdated) {
      this.componentDidMount();
    }
  };

  setShowModalProcessStatusDelete = (showModalProcessStatusDelete, selectedProcessStatus, wasUpdated) => {
    this.setState({
      showModalProcessStatusDelete,
      selectedProcessStatus
    });
    if (!showModalProcessStatusDelete && wasUpdated) {
      this.componentDidMount();
    }
  };

  setShowModalProcessTypeDelete = (showModalProcessTypeDelete, selectedProcessType, wasUpdated) => {
    this.setState({
      showModalProcessTypeDelete,
      selectedProcessType
    });
    if (!showModalProcessTypeDelete && wasUpdated) {
      this.componentDidMount();
    }
  };

  setShowModalScenario = (showModalScenario, item, wasUpdated) => {
    this.setState({
      showModalScenario,
      id: item?.id ?? null,
      name: item?.name ?? null,
      description: item?.description ?? null,
    });
    if (!showModalScenario && wasUpdated) {
      this.componentDidMount();
    }
  };

  setShowModalRetirementType = (showModalRetirementType, item, wasUpdated) => {
    this.setState({
      showModalRetirementType,
      id: item?.id ?? null,
      description: item?.description ?? null,
    });
    if (!showModalRetirementType && wasUpdated) {
      this.componentDidMount();
    }
  };

  setShowModalScenarioDelete = (showModalScenarioDelete, item, wasUpdated) => {
    this.setState({
      showModalScenarioDelete,
      id: item?.id ?? null,
      name: item?.name ?? null,
    });
    if (!showModalScenarioDelete && wasUpdated) {
      this.componentDidMount();
    }
  };

  setShowEditPaymentMethodModal = (
    showEditPaymentMethodModal,
    paymentMethod,
    wasUpdated
  ) => {
    this.setState({
      showEditPaymentMethodModal,
      paymentMethod,
    });

    if (!showEditPaymentMethodModal && wasUpdated) {
      this.componentDidMount();
    }
  };

  // Filtra a lista no próprio JavaScript, por qualquer valor de coluna (string/número)
  filterList = (list, term) => {
    if (!list) return list;
    const t = (term ?? "").trim().toLowerCase();
    if (!t) return list;
    return list.filter((item) =>
      Object.values(item).some(
        (value) =>
          (typeof value === "string" || typeof value === "number") &&
          String(value).toLowerCase().includes(t)
      )
    );
  };

  RenderCardTitle = ({ title, onButtonClick, filterValue, onFilterChange }) => {
    return (
      <div className="card-title-height">
        <Row className="align-items-center">
          <Col>
            <h4>{title}</h4>
          </Col>
          <Col xs="auto" className="text-right my-2 ml-2">
            <div className="d-flex align-items-center justify-content-end">
              {onFilterChange ? (
                <input
                  type="text"
                  className="form-control form-control-sm mr-2"
                  style={{ maxWidth: "180px" }}
                  placeholder="Filtrar..."
                  value={filterValue ?? ""}
                  onChange={(e) => onFilterChange(e.target.value)}
                />
              ) : null}
              {onButtonClick ? (
                <Button
                  variant="primary"
                  className="text-nowrap"
                  onClick={onButtonClick}
                >
                  <i className="fas fa-plus-circle pr-2" />
                  <span>Adicionar</span>
                </Button>
              ) : null}
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  render() {
    const {
      allProcessType,
      allProcessStatus,
      showModalProcessType,
      showModalProcessStatus,
      showModalEditProcessStatus,
      id,
      name,
      deadlineDays,
      selectedDocuments,
      parcel,
      typeOfPayment,
      payAtTheBeginning,
      value,
      isTicketParcel,
      ticketParcel,
      isCreditCard,
      creditCardParcel,
      description,
      contracts,
      allScenarios,
      showModalScenario,
      showModalScenarioDelete,
      showModalRetirementType,
      loadingCount,
      // PAYMENT METHOD MODAL
      showEditPaymentMethodModal,
      paymentMethod,
      // DELETE PROCESS STATUS MODAL
      showModalProcessStatusDelete,
      selectedProcessStatus,
      // DELETE PROCESS TYPE MODAL
      showModalProcessTypeDelete,
      selectedProcessType,
    } = this.state;

    return (
      <Loading loading={loadingCount !== 0}>
        <Header active="Configurações de processos" logged />
        <PageContainer withoutCard>
          <Row className="m-n2">
            {/* Status de processo */}
            <Col xs={12} className="p-0">
              <div className="p-3 m-2 card card-conf-action-size">
                <this.RenderCardTitle
                  title="Status de processo"
                  onButtonClick={
                    this.props.privileges?.["configuracoes/processos"]?.create
                      ? () => this.setShowModalProcessStatus(true)
                      : null
                  }
                  filterValue={this.state.filterProcessStatus}
                  onFilterChange={(v) => this.setState({ filterProcessStatus: v })}
                />

                <TableComponent
                  loading={loadingCount !== 0}
                  countLabel="status"
                  startSorted="id"
                  header={[
                    { label: "#", sortProperty: "id" },
                    { label: "Nome", sortProperty: "name" },
                    { label: "Remover" }
                  ]}
                  currentList={this.state.currentAllProcessStatus}
                  setCurrentList={(currentAllProcessStatus) =>
                    this.setState({ currentAllProcessStatus })
                  }
                  key={`process-status-${this.state.filterProcessStatus || ""}`}
                  list={this.filterList(
                    this.state.allProcessStatusList,
                    this.state.filterProcessStatus
                  )}
                  onItemClick={(listItem) => {
                    const item = allProcessStatus.find(
                      (it) => it.id === listItem.id
                    );
                    this.setShowModalEditProcessStatus(true, item);
                  }}
                  forEach={(item) => [
                    { label: item.id },
                    { label: item.name },
                    {
                      onClick: () =>
                        this.setShowModalProcessStatusDelete(true, item),
                      label: (
                        <div className="text-center">
                          <i className="fas fa-trash-alt is-required"></i>
                        </div>
                      ),
                    }
                  ]}
                />
              </div>
            </Col>

            {/* Tipo de tese */}
            <Col xs={12} className="p-0">
              <div className="p-3 m-2 card card-conf-action-size">
                <this.RenderCardTitle
                  title="Tipo de tese"
                  onButtonClick={
                    this.props.privileges?.["configuracoes/processos"]?.create
                      ? () => this.setShowModalProcessType(true)
                      : null
                  }
                  filterValue={this.state.filterProcessType}
                  onFilterChange={(v) => this.setState({ filterProcessType: v })}
                />

                <TableComponent
                  loading={loadingCount !== 0}
                  countLabel="tipos"
                  countLabelSingular="tipo"
                  startSorted="id"
                  header={[
                    { label: "#", sortProperty: "id" },
                    { label: "Nome", sortProperty: "name" },
                    { label: "Documentos", sortProperty: "documentsLength" },
                    { label: "Remover" }
                  ]}
                  currentList={this.state.currentAllProcessType}
                  setCurrentList={(currentAllProcessType) =>
                    this.setState({ currentAllProcessType })
                  }
                  key={`process-type-${this.state.filterProcessType || ""}`}
                  list={this.filterList(
                    this.state.allProcessTypeList,
                    this.state.filterProcessType
                  )}
                  onItemClick={(listItem) => {
                    const item = allProcessType.find(
                      (it) => it.id === listItem.id
                    );
                    this.setShowModalProcessType(true, item);
                  }}
                  forEach={(item) => [
                    { label: item.id },
                    { label: item.name },
                    { label: item.documentsLength },
                    {
                      onClick: () =>
                        this.setShowModalProcessTypeDelete(true, item),
                      label: (
                        <div className="text-center">
                          <i className="fas fa-trash-alt is-required"></i>
                        </div>
                      ),
                    }
                  ]}
                />
              </div>
            </Col>
            <Col xs={12} className="p-0">
              <div className="p-3 m-2 card card-conf-action-size">
                <this.RenderCardTitle
                  title="Cenário"
                  onButtonClick={
                    this.props.privileges?.["configuracoes/processos"]?.create
                      ? () => this.setShowModalScenario(true)
                      : null
                  }
                  filterValue={this.state.filterScenario}
                  onFilterChange={(v) => this.setState({ filterScenario: v })}
                />

                <TableComponent
                  loading={loadingCount !== 0}
                  countLabel="cenários"
                  countLabelSingular="cenário"
                  startSorted="id"
                  header={[
                    { label: "#", sortProperty: "id" },
                    { label: "Nome", sortProperty: "name" },
                    { label: "Descrição", sortProperty: "description" },
                    this.props.privileges?.["configuracoes/processos"]?.delete
                      ? { label: "Excluir" }
                      : null,
                  ]}
                  currentList={this.state.currentAllScenarios}
                  setCurrentList={(currentAllScenarios) =>
                    this.setState({ currentAllScenarios })
                  }
                  key={`scenario-${this.state.filterScenario || ""}`}
                  list={this.filterList(
                    this.state.allScenariosList,
                    this.state.filterScenario
                  )}
                  onItemClick={(listItem) => {
                    const item = allScenarios.find(
                      (it) => it.id === listItem.id
                    );
                    this.setShowModalScenario(true, item);
                  }}
                  forEach={(item) => [
                    { label: item.id },
                    { label: item.name },
                    { label: item.description },
                    this.props.privileges?.["configuracoes/processos"]?.delete
                      ? {
                        onClick: () =>
                          this.setShowModalScenarioDelete(true, item),
                        label: (
                          <div className="text-center">
                            <i className="fas fa-trash-alt is-required"></i>
                          </div>
                        ),
                      }
                      : null,
                  ]}
                />
              </div>
            </Col>

            <Col xs={12} className="p-0">
              <div className="p-3 m-2 card card-conf-action-size">
                <this.RenderCardTitle
                  title="Tipo de Aposentadoria"
                  onButtonClick={
                    this.props.privileges?.["configuracoes/processos"]?.create
                      ? () => this.setShowModalRetirementType(true)
                      : null
                  }
                  filterValue={this.state.filterRetirementType}
                  onFilterChange={(v) =>
                    this.setState({ filterRetirementType: v })
                  }
                />

                <TableComponent
                  loading={loadingCount !== 0}
                  countLabel="Tipos de Aposentadoria"
                  countLabelSingular="Tipos de Aposentadoria"
                  startSorted="id"
                  header={[
                    {label: "#", sortProperty: "id"},
                    {label: "Descrição", sortProperty: "description"},
                    this.props.privileges?.["configuracoes/processos"]?.delete ? {label: "Excluir"} : null
                  ]}
                  currentList={this.state.currentAllRetirementType}
                  setCurrentList={(currentAllRetirementType) => this.setState({currentAllRetirementType})}
                  key={`retirement-type-${this.state.filterRetirementType || ""}`}
                  list={this.filterList(
                    this.state.allRetirementType,
                    this.state.filterRetirementType
                  )}
                  onItemClick={(listItem) => {
                    const item = this.state.allRetirementType.find((it) => it.id === listItem.id);
                    this.setShowModalRetirementType(true, item);
                  }}
                  forEach={(item) => [
                    {label: item.id},
                    {label: item.description},
                    this.props.privileges?.["configuracoes/processos"]?.delete
                      ? {
                        onClick: async () => {
                          const confirmed = await this.props.confirm('Deseja realmente excluir?', {
                            title: 'Alerta',
                            btnConfirm: 'Sim',
                            btnCancel: 'Não',
                          });
                          if (!confirmed) return;

                          await deleteRetirementType(item.id);
                          this.props.onAddAlert("Registro excluído com sucesso!", "success", false);
                          this.componentDidMount();
                        },
                        label: (
                          <div className="text-center">
                            <i className="fas fa-trash-alt is-required"></i>
                          </div>
                        ),
                      }
                      : null,
                  ]}
                />
              </div>
            </Col>
          </Row>

          {showModalProcessType && (
            <ModalProcessType
              show={showModalProcessType}
              onHide={(wasUpdated) =>
                this.setShowModalProcessType(false, null, wasUpdated)
              }
              id={id}
              name={name}
              selectedDocuments={selectedDocuments}
              deadlineDays={deadlineDays}
              parcel={parcel}
              typeOfPayment={typeOfPayment}
              payAtTheBeginning={payAtTheBeginning}
              value={value}
              contracts={contracts}
              isTicketParcel={isTicketParcel}
              ticketParcel={ticketParcel}
              isCreditCard={isCreditCard}
              creditCardParcel={creditCardParcel}
            />
          )}
          {showModalProcessStatus && (
            <ModalProcessStatus
              show={showModalProcessStatus}
              onHide={(wasUpdated) =>
                this.setShowModalProcessStatus(false, null, wasUpdated)
              }
            />
          )}
          {showModalEditProcessStatus && id && name && (
            <ModalProcessStatus
              show={showModalEditProcessStatus}
              onHide={(wasUpdated) =>
                this.setShowModalEditProcessStatus(false, null, wasUpdated)
              }
              id={id}
              name={name}
            />
          )}
          {showModalScenario && (
            <ModalScenario
              show={showModalScenario}
              onHide={(wasUpdated) =>
                this.setShowModalScenario(false, null, wasUpdated)
              }
              id={id}
              name={name}
              description={description}
            />
          )}
          {showModalRetirementType && (
            <ModalRetirementType
              show={showModalRetirementType}
              onHide={(wasUpdated) =>
                this.setShowModalRetirementType(false, null, wasUpdated)
              }
              id={id}
              description={description}
            />
          )}
          {showModalScenarioDelete && id && name && (
            <ModalScenarioDelete
              show={showModalScenarioDelete}
              onHide={(wasUpdated) =>
                this.setShowModalScenarioDelete(false, null, wasUpdated)
              }
              id={id}
              name={name}
            />
          )}

          {showEditPaymentMethodModal && paymentMethod && (
            <ModalPaymentMethod
              show={showEditPaymentMethodModal}
              onHide={(wasUpdated) =>
                this.setShowEditPaymentMethodModal(false, null, wasUpdated)
              }
              paymentMethod={paymentMethod}
            />
          )}

          {showModalProcessStatusDelete && (
            <ModalProcessStatusDelete
              show={showModalProcessStatusDelete}
              onHide={(wasUpdated) =>
                this.setShowModalProcessStatusDelete(false, null, wasUpdated)
              }
              processStatus={selectedProcessStatus}
            />
          )}

          {showModalProcessTypeDelete && (
            <ModalProcessTypeDelete
              show={showModalProcessTypeDelete}
              onHide={(wasUpdated) =>
                this.setShowModalProcessTypeDelete(false, null, wasUpdated)
              }
              processType={selectedProcessType}
            />
          )}
        </PageContainer>
      </Loading>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAddAlert: (text, alertType, alertPriority) =>
      dispatch(alertActions.addAlert(text, alertType, alertPriority)),
  };
};

export default withConfirm(connect(null, mapDispatchToProps)(SettingsProcessPage));
